// =========================================================================================@@
// Status Level: 2
// ===========================================================================================

import { useMutation } from '@apollo/client'
import { createOrganization as createOrganizationGql }
   from 'src/core/graphql/mutations/createOrganization.gql'

const useCreateOrganization = (mutationHookOptions) => {
   const [createOrganization, { called, client, data, error, loading }] =
      useMutation(createOrganizationGql, mutationHookOptions)

   const wrappedMutationFn = (variables, mutationFnOptions) => createOrganization({
      variables,
      ...mutationFnOptions
   })

   return {
      createOrganization: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useCreateOrganization
